import { useEffect, useState } from "react";
import { Button } from "@mui/material";

const CountdownTimer = ({ onResendOtp }) => {
  const [timeLeft, setTimeLeft] = useState(120); // 2 minutes in seconds
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);

      return () => clearInterval(timer); // Cleanup on unmount
    } else {
      setIsDisabled(false); // Enable button after countdown ends
    }
  }, [timeLeft]);

  const handleResendOtp = () => {
    setTimeLeft(120); // Reset countdown to 2 minutes
    setIsDisabled(true); // Disable button again
    onResendOtp(); // Call the resend OTP function
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
      2,
      "0"
    )}`;
  };

  return (
    <div
      className="flex justify-around items-center w-full"
      style={{ fontSize: "16px", fontFamily: "Roboto" }}
    >
      <p>{formatTime(timeLeft)}</p>
      <Button
        onClick={handleResendOtp}
        disabled={isDisabled}
        variant="outlined"
        sx={{ width: "120px", fontSize: "12px" }}
      >
        Resend OTP
      </Button>
    </div>
  );
};

export default CountdownTimer;
